import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { UserService } from '../../services/user/user.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DialogService } from '../../services/dialog/dialog.service';

interface AgreementLink {
  title: string; 
  url?: string;           // open in a new tab (like Privacy Policy)
  action?: 'openTosDialog'; // open our TOS dialog
}

@Component({
    selector: 'app-user-agreements',
    imports: [MatDialogModule],
    templateUrl: './user-agreements.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './user-agreements.component.scss'
})
export class UserAgreementsComponent implements OnInit {
  private _userService: UserService = inject(UserService);
private dialogService = inject(DialogService);

  private supplierLinks: AgreementLink[] = [
    // if suppliers should see TOS too, add it here as well:
    { title: 'Credit Terms & Conditions', action: 'openTosDialog' },
    { 
    title: 'Privacy Policy', 
    url: 'https://www.transendfinancial.com/privacy-policy' 
  }
  ];

  private borrowerLinks: AgreementLink[] = [
    { title: 'Credit Terms & Conditions', action: 'openTosDialog' },
    { title: 'Privacy Policy - Bank', url: 'assets/agreements/MSB_U.S._Consumer_Privacy_Notice_-_July_2025.pdf' },
  ];

  currentLinks: AgreementLink[] = [];

  ngOnInit() {
    const role = this._userService.company?.companyType;
    if (role === 'SUPPLIER') {
      this.currentLinks = this.supplierLinks;
    } else if (role === 'BORROWER') {
      this.currentLinks = this.borrowerLinks;
    }
  }

  openLink(link: AgreementLink) {
  if (link.url) {
    // let the anchor handle it in template
    return;
  }

  if (link.action === 'openTosDialog') {
    this.dialogService.openTosViewerDialog().subscribe({
      next: () => {
        // optional: do something after close
      },
      error: (err) => {
        console.error('TOS dialog error', err);
      }
    });
  }
}

}
